import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { RootState } from '@kopapro-redux/store';
import DiscountCodeSection from '@kopapro/components/checkout/discountCode/discountCode';
import { withTranslation, WithTranslation } from 'react-i18next';
import { getCartDiscountCodes } from '@kopapro-redux/selectors/entities/cart';
import { addDiscountCodesToOrder } from '@kopapro-redux/actions/checkout';
import { getShopOrderSetup } from '@kopapro-redux/selectors/entities/shop';
import { withNavigation } from '@kopapro/components/commons/router-hoc';
interface IProps extends WithTranslation {
  currentSection: string;
  allowEditDiscount: boolean;
  hideErrorMessage?: boolean;
  navigate: any;
}

interface StateProps {
  discountCodes: string[];
  allowMultiDiscountCode: boolean;
}

interface DispatchProps {
  addDiscountCodes: typeof addDiscountCodesToOrder;
}

const mapStateToProps: MapStateToProps<StateProps, IProps, RootState> = (state: RootState, props: IProps) => {
  return {
    discountCodes: getCartDiscountCodes(state),
    allowMultiDiscountCode: getShopOrderSetup(state).allowMutiDiscCode,
  };
};

const mapDispatchToProps: MapDispatchToProps<DispatchProps, IProps> = {
  addDiscountCodes: addDiscountCodesToOrder,
};

export type DiscountCodeSectionProps = IProps & StateProps & DispatchProps;
export default withNavigation(withTranslation()(connect(mapStateToProps, mapDispatchToProps)(DiscountCodeSection)));
